import RcDomainObject from "../../../common/RcDomainObject";
import GpsDevice from "../device/GpsDevice.js";
import RcTime from "../../../session/time/RcTime.js";

export default class GpsPosition extends RcDomainObject {

  static MODEL_NAME = "GpsPosition";

  static FIELDS = {
    GPS_DEVICE: 'GpsDevice',
    DEVICE_TIME: "deviceTime",
    PROTOCOL: "protocol",
    LATITUDE: "lat",
    LONGITUDE: "lon",
    SPEED: "speed",
    COURSE: "course",
    VALID: "valid",
    SATELLITE_COUNT: "satelliteCount",
    MCC: "mcc",
    MNC: "mnc",
    LAC: "lac",
    CELL_ID: "cellId",
    IGNITION: "ignition",
    CHARGING: "charging",
    GPS_TRACKING: "gpsTracking",
    OIL_CONNECTED: "oilConnected",
    DEFENSE: "defense",
    BATTERY_LEVEL: "batteryLevel",
    GSM_SIGNAL: "gsmSignal",
    ALARM: "alarm",
  }

  constructor(domain, data) {
    super(domain, data, GpsPosition.MODEL_NAME);
  }

  fields() {
    return GpsPosition.FIELDS;
  }

  gpsDevice() {
    var value = this.get(GpsPosition.FIELDS.GPS_DEVICE);
    return new GpsDevice(this.domain, value);
  }

  withGpsDevice(gpsDevice) {
    this.put(GpsPosition.FIELDS.GPS_DEVICE, gpsDevice);
    return this;
  }

  deviceTime() {
    return this.getString(GpsPosition.FIELDS.DEVICE_TIME);
  }

  withDeviceTime(deviceTime) {
    this.put(GpsPosition.FIELDS.DEVICE_TIME, deviceTime);
    return this;
  }

  protocol() {
    return this.getInt(GpsPosition.FIELDS.PROTOCOL);
  }

  withProtocol(protocol) {
    this.put(GpsPosition.FIELDS.PROTOCOL, protocol);
    return this;
  }

  latitude() {
    return this.getDouble(GpsPosition.FIELDS.LATITUDE);
  }

  withLatitude(latitude) {
    this.put(GpsPosition.FIELDS.LATITUDE, latitude);
    return this;
  }

  longitude() {
    return this.getDouble(GpsPosition.FIELDS.LONGITUDE);
  }

  withLongitude(longitude) {
    this.put(GpsPosition.FIELDS.LONGITUDE, longitude);
    return this;
  }

  speed() {
    return this.getDouble(GpsPosition.FIELDS.SPEED);
  }

  withSpeed(speed) {
    this.put(GpsPosition.FIELDS.SPEED, speed);
    return this;
  }

  course() {
    return this.getDouble(GpsPosition.FIELDS.COURSE);
  }

  withCourse(course) {
    this.put(GpsPosition.FIELDS.COURSE, course);
    return this;
  }

  valid() {
    return this.getBoolean(GpsPosition.FIELDS.VALID);
  }

  withValid(valid) {
    this.put(GpsPosition.FIELDS.VALID, valid);
    return this;
  }

  satelliteCount() {
    return this.getInt(GpsPosition.FIELDS.SATELLITE_COUNT);
  }

  withSatelliteCount(satelliteCount) {
    this.put(GpsPosition.FIELDS.SATELLITE_COUNT, satelliteCount);
    return this;
  }

  mcc() {
    return this.getInt(GpsPosition.FIELDS.MCC);
  }

  withMcc(mcc) {
    this.put(GpsPosition.FIELDS.MCC, mcc);
    return this;
  }

  mnc() {
    return this.getInt(GpsPosition.FIELDS.MNC);
  }

  withMnc(mnc) {
    this.put(GpsPosition.FIELDS.MNC, mnc);
    return this;
  }

  lac() {
    return this.getInt(GpsPosition.FIELDS.LAC);
  }

  withLac(lac) {
    this.put(GpsPosition.FIELDS.LAC, lac);
    return this;
  }

  cellId() {
    return this.getString(GpsPosition.FIELDS.CELL_ID);
  }

  withCellId(cellId) {
    this.put(GpsPosition.FIELDS.CELL_ID, cellId);
    return this;
  }

  ignition() {
    return this.getBoolean(GpsPosition.FIELDS.IGNITION);
  }

  withIgnition(ignition) {
    this.put(GpsPosition.FIELDS.IGNITION, ignition);
    return this;
  }

  charging() {
    return this.getBoolean(GpsPosition.FIELDS.CHARGING);
  }

  withCharging(charging) {
    this.put(GpsPosition.FIELDS.CHARGING, charging);
    return this;
  }

  gpsTracking() {
    return this.getBoolean(GpsPosition.FIELDS.GPS_TRACKING);
  }

  withGpsTracking(gpsTracking) {
    this.put(GpsPosition.FIELDS.GPS_TRACKING, gpsTracking);
    return this;
  }

  oilConnected() {
    return this.getBoolean(GpsPosition.FIELDS.OIL_CONNECTED);
  }

  withOilConnected(oilConnected) {
    this.put(GpsPosition.FIELDS.OIL_CONNECTED, oilConnected);
    return this;
  }

  defense() {
    return this.getBoolean(GpsPosition.FIELDS.DEFENSE);
  }

  withDefense(defense) {
    this.put(GpsPosition.FIELDS.DEFENSE, defense);
    return this;
  }

  batteryLevel() {
    return this.getInt(GpsPosition.FIELDS.BATTERY_LEVEL);
  }

  withBatteryLevel(batteryLevel) {
    this.put(GpsPosition.FIELDS.BATTERY_LEVEL, batteryLevel);
    return this;
  }

  gsmSignal() {
    return this.getInt(GpsPosition.FIELDS.GSM_SIGNAL);
  }

  withGsmSignal(gsmSignal) {
    this.put(GpsPosition.FIELDS.GSM_SIGNAL, gsmSignal);
    return this;
  }

  alarm() {
    return this.getString(GpsPosition.FIELDS.ALARM);
  }

  withAlarm(alarm) {
    this.put(GpsPosition.FIELDS.ALARM, alarm);
    return this;
  }

  deviceTimeDisplay() {
    let time = this.deviceTime();
    if (time <= 0) {
      return 'No update received';
    }
    let rcTime = RcTime.time();
    let lastUpdate = rcTime.at(time);
    return lastUpdate.displayAs_YYYY_MM_DD_HH_MM_SS_A();
  }
}
